import React from 'react'
import AppMain from 'src/core/gd-app/component/app-main/app-main'

import Confirmation from '../confirmation/confirmation'
import RequestForm_FormView from "../../../../app/tools/request-forms2/view-form/form-view"
import {SharedViewLogoTopPanel} from "../../../core/logo/logo-top-panel"

export default class Main extends React.Component {

    constructor(props) {
        super(props);

        this.state = {
            view: 'form'
        }
    }

    onNewRequest = () => {
        this.setState({
            view: 'form'
        })
    }

    onSubmit = (result) => {
        this.setState({
            view: 'confirmation'
        })
    }

    reRender() {
        this.setState({
            reRender: true
        })
    }

    render() {

        switch (this.state.view) {
            case 'confirmation':
                return (
                    <AppMain type="full">
                        <Confirmation app={this.props.app} onNewRequest={this.onNewRequest}/>
                    </AppMain>
                )

            default:
                return (
                    <AppMain type="full">
                        <SharedViewLogoTopPanel className   = "form-logo"
                                                logo        = {this.props.app.requestForm.settings.logo}/>

                        <div className="ui5-request-form">
                            <RequestForm_FormView publicKey     = {this.props.app.publicKey}
                                                  requestForm   = {this.props.app.requestForm}
                                                  onSubmit      = {this.onSubmit}/>
                        </div>
                    </AppMain>
                )
        }
    }
}
